import React from "react";
import Cookies from "js-cookie";
import ReactDOM from "react-dom/client";
import AdultWarningModal from "./components/AdultWarningModal";

export default new class AdultWarningFormService {
    private readonly CookieName = "adlt";
    private readonly CookieValue = "1";
    private readonly CookieExpiration = 365;

    public init(): void {
        if (Cookies.get(this.CookieName) === this.CookieValue) {
            return;
        }

        const containerElement = document.createElement("div");
        const root = ReactDOM.createRoot(containerElement);

        root.render(<AdultWarningModal
            onConfirmAdultContent={(): void => this.confirmAdultContent()}
            onAfterClose={(): void => {
                root.unmount();
                containerElement.remove();
            }}
        />);
    }

    private confirmAdultContent(): void {
        Cookies.set(this.CookieName, this.CookieValue, { expires: this.CookieExpiration });
    }
}();
